module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_moere_og_romsdal_neg.68e32751.png";